import { EntityTypes } from '@squaredup/constants';
import type { Serialised } from '@squaredup/ids';
import type { DataStreamDefinitionEntity } from 'dynamo-wrapper';
import type { DataStream } from 'services/DataStreamDefinitionService';

/**
 * If true, this data stream was saved by a user to a specific plugin config.
 */
export const isSavedDataStream = (dataStream: Serialised<DataStreamDefinitionEntity>): boolean =>
    dataStream.parentPluginId?.startsWith(EntityTypes.CONFIG) ?? false;

/**
 * Returns true if a data stream is linked to a specific plugin config.
 */
export const isLinkedToPluginConfig = (pluginId: string, configId: string, dataStream: DataStream) => {
    return (
        (isSavedDataStream(dataStream) && dataStream.parentPluginId === configId) ||
        (dataStream.pluginId === pluginId && dataStream.parentPluginId?.startsWith(EntityTypes.PLUGIN + '-'))
    );
};
